<template>
  <Layout>
    <q-page>
      <div class="q-pa-xl centered-container-small">
        <div class="col-12">
          <span class="text-h4">{{ i18n.page_title }}</span>
        </div>

        <div class="col-12 q-pt-xl">
          <div
            v-if="invoices.length == 0"
            class="text-center"
          >
            <p class="text-bold q-mt-md">
              {{ i18n.invoices_empty }}
            </p>
          </div>

          <q-markup-table
            v-if="invoices.length"
            flat
          >
            <tbody>
              <tr
                v-for="invoice in invoices"
                :key="invoice.id"
              >
                <td class="text-left text-bold">
                  {{ invoice.number }}
                </td>
                <td class="text-left">
                  {{ invoice.created }}
                </td>
                <td class="text-right">
                  {{ invoice.amount }}
                </td>
                <td class="text-center">
                  <q-chip
                    size="12px"
                    :class="invoice_status_class(invoice)"
                  >
                    {{ invoice.status }}
                  </q-chip>
                </td>
                <td class="text-right">
                  <a
                    v-if="invoice.file_url"
                    :href="invoice.file_url"
                    download
                  >
                    <q-btn
                      flat
                      icon="las la-download"
                      color="primary"
                      round
                      no-caps
                    />
                  </a>
                  <a
                    v-if="invoice.file_hosted_url"
                    :href="invoice.file_hosted_url"
                    target="_blank"
                  >
                    <q-btn
                      flat
                      icon="link"
                      color="primary"
                      round
                      no-caps
                    />
                  </a>
                </td>
              </tr>
            </tbody>
          </q-markup-table>

          <q-inner-loading :showing="false">
            <q-spinner-tail
              color="primary"
              size="lg"
            />
          </q-inner-loading>
        </div>
      </div>
    </q-page>
  </Layout>
</template>
<script>
import Layout from '@/layouts/wide.vue';

export default {
  components: {
    Layout,
  },
  props: {
    i18n: {
      type: Object,
      required: true,
    },
    invoices: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
    };
  },
  computed: {
  },
  watch: {
  },
  methods: {
    invoice_status_class: function(invoice) {
      switch (invoice.status) {
      case "draft":
        return "invoice-status-draft";
      case "deleted":
        return "invoice-status-deleted";
      case "open":
        return "invoice-status-open";
      case "paid":
        return "invoice-status-paid";
      case "uncollectible":
        return "invoice-status-uncollectible";
      case "void":
        return "invoice-status-void";
      default:
        return "";
      }
    },
  },
};
</script>
<style scoped>
.q-item {
  user-select: text;
}
</style>
